import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A cellular antenna monopole: a smooth steel pole carrying a triangular head
// frame of panel antennas, a small dish and a hanging cable run. The slim
// roadside cell site, distinct from the lattice radio tower.
const POLE = "#9aa0a6";
const POLE_DK = "#7c8288";
const FRAME = "#6c727a";
const PANEL = "#cfd2d4";
const DISH = "#d6d9dc";
const CABLE = "#23232a";

export const antennaMast = defineModel({
  id: "antenna-mast",
  batchId: "electric",
  name: "Antenna mast",
  tags: ["prop", "electric", "power", "telecom", "antenna", "cell"],
  summary: "A monopole cell mast with a triangular panel-antenna head.",
  footprint: 0.4,
  parts(): Part[] {
    const parts: Part[] = [
      { geometry: new THREE.CylinderGeometry(0.12, 0.14, 0.12, 12), color: POLE_DK, position: [0, 0.06, 0] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.09, 2.0, 12), color: POLE, position: [0, 1.05, 0] },
      // Triangular head frame near the top.
      { geometry: new THREE.CylinderGeometry(0.26, 0.26, 0.04, 3), color: FRAME, position: [0, 1.86, 0] },
      { geometry: new THREE.CylinderGeometry(0.26, 0.26, 0.04, 3), color: FRAME, position: [0, 2.06, 0] },
    ];
    // Three panel antennas on the head frame corners.
    for (let i = 0; i < 3; i++) {
      const a = i * (Math.PI * 2 / 3) + Math.PI / 2;
      const r = 0.28;
      parts.push({ geometry: new THREE.BoxGeometry(0.1, 0.4, 0.16), color: PANEL, position: [Math.cos(a) * r, 1.96, Math.sin(a) * r], rotation: [0, -a, 0] });
    }
    // A small dish and a hanging cable run.
    parts.push(
      { geometry: new THREE.CylinderGeometry(0.001, 0.12, 0.07, 12), color: DISH, position: [0.26, 1.6, 0.1], rotation: [1.3, 0, 0.3] },
      { geometry: new THREE.CylinderGeometry(0.02, 0.02, 1.7, 6), color: CABLE, position: [0.07, 1.0, 0.02] },
    );
    return parts;
  },
  animations: [],
});
